const padWithZeroes = (number, length) => {
  let styledNumber = '' + number
  while (styledNumber.length < length) {
    styledNumber = '0' + styledNumber
  }

  return styledNumber
}

export default padWithZeroes
